export const initialValues = {
  equipmentId: '',
  userId: '',
  durationHours: 1,
  startDate: new Date().toISOString().split('T')[0],
  startTime: '09:00',
};

export const DURATION_OPTIONS = [
  { value: 1, label: '1 hora' },
  { value: 2, label: '2 horas' },
  { value: 4, label: '4 horas' },
  { value: 6, label: '6 horas' },
  { value: 8, label: '8 horas' },
  { value: 12, label: '12 horas' },
  { value: 24, label: '24 horas' },
]; 